"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("styled-components");
var _format = _interopRequireDefault(require("date-fns/format"));
var _startOfDay = _interopRequireDefault(require("date-fns/startOfDay"));
var _endOfDay = _interopRequireDefault(require("date-fns/endOfDay"));
var _startOfMonth = _interopRequireDefault(require("date-fns/startOfMonth"));
var _endOfMonth = _interopRequireDefault(require("date-fns/endOfMonth"));
var _startOfWeek = _interopRequireDefault(require("date-fns/startOfWeek"));
var _endOfWeek = _interopRequireDefault(require("date-fns/endOfWeek"));
var _isBefore = _interopRequireDefault(require("date-fns/isBefore"));
var _isSameDay = _interopRequireDefault(require("date-fns/isSameDay"));
var _isAfter = _interopRequireDefault(require("date-fns/isAfter"));
var _isWeekend = _interopRequireDefault(require("date-fns/isWeekend"));
var _isWithinInterval = _interopRequireDefault(require("date-fns/isWithinInterval"));
var _eachDayOfInterval = _interopRequireDefault(require("date-fns/eachDayOfInterval"));
var _differenceInWeeks = _interopRequireDefault(require("date-fns/differenceInWeeks"));
var _addWeeks = _interopRequireDefault(require("date-fns/addWeeks"));
var _lodash = _interopRequireDefault(require("lodash.noop"));
var _oxygenConfig = require("@8x8/oxygen-config");
var StyledMonth = _interopRequireWildcard(require("../styled/MonthGrid"));
var _Day = _interopRequireDefault(require("./Day"));
var _constants = _interopRequireDefault(require("../constants"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function getMonthDisplayRange(date, dateOptions) {
  var startDateOfMonth = (0, _startOfMonth["default"])(date, dateOptions);
  var endDateOfMonth = (0, _endOfMonth["default"])(date, dateOptions);
  var start = (0, _startOfWeek["default"])(startDateOfMonth, dateOptions);
  var end = (0, _endOfWeek["default"])(endDateOfMonth, dateOptions);
  if (dateOptions.customEvenMonths) {
    var diff = (0, _differenceInWeeks["default"])(end, start, dateOptions);
    end = (0, _endOfWeek["default"])((0, _addWeeks["default"])(end, 5 - diff), dateOptions);
  }
  return {
    start: start,
    end: end,
    startDateOfMonth: startDateOfMonth,
    endDateOfMonth: endDateOfMonth
  };
}
var Month = /*#__PURE__*/function (_PureComponent) {
  _inherits(Month, _PureComponent);
  var _super = _createSuper(Month);
  function Month() {
    var _this;
    _classCallCheck(this, Month);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "isDayDisabled", function (day) {
      var _this$props = _this.props,
        disabledDates = _this$props.disabledDates,
        enabledDates = _this$props.enabledDates;
      if (disabledDates.length) {
        return disabledDates.some(function (disabledDate) {
          return (0, _isSameDay["default"])(disabledDate, day);
        });
      }
      return !!enabledDates.length && enabledDates.every(function (enabledDate) {
        return !(0, _isSameDay["default"])(enabledDate, day);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderMonthName", function () {
      var _this$props2 = _this.props,
        testId = _this$props2.testId,
        month = _this$props2.month,
        dateOptions = _this$props2.dateOptions,
        monthDisplayFormat = _this$props2.monthDisplayFormat,
        locale = _this$props2.locale;
      var formatOptions = _objectSpread(_objectSpread({}, dateOptions), {}, {
        locale: locale
      });
      return /*#__PURE__*/_react["default"].createElement(StyledMonth.MonthName, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_MONTH_NAME")), (0, _format["default"])(month, monthDisplayFormat, formatOptions));
    });
    _defineProperty(_assertThisInitialized(_this), "renderWeekDays", function () {
      var _this$props3 = _this.props,
        testId = _this$props3.testId,
        dateOptions = _this$props3.dateOptions,
        weekDayDisplayFormat = _this$props3.weekDayDisplayFormat,
        locale = _this$props3.locale;
      var now = Date.now();
      var formatOptions = _objectSpread(_objectSpread({}, dateOptions), {}, {
        locale: locale
      });
      return /*#__PURE__*/_react["default"].createElement(StyledMonth.WeekDays, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_WEEK_DAYS")), (0, _eachDayOfInterval["default"])({
        start: (0, _startOfWeek["default"])(now, dateOptions),
        end: (0, _endOfWeek["default"])(now, dateOptions)
      }).map(function (day) {
        return /*#__PURE__*/_react["default"].createElement(StyledMonth.WeekDay, {
          key: day.toString()
        }, (0, _format["default"])(day, weekDayDisplayFormat, formatOptions));
      }));
    });
    return _this;
  }
  _createClass(Month, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var now = Date.now();
      var _this$props4 = this.props,
        month = _this$props4.month,
        testId = _this$props4.testId,
        dateOptions = _this$props4.dateOptions,
        displayMode = _this$props4.displayMode,
        showPreview = _this$props4.showPreview,
        preview = _this$props4.preview,
        range = _this$props4.range,
        date = _this$props4.date,
        dayNumberFormat = _this$props4.dayNumberFormat,
        locale = _this$props4.locale,
        showWeekDays = _this$props4.showWeekDays,
        showMonthName = _this$props4.showMonthName,
        onDayClick = _this$props4.onDayClick,
        onPreviewChange = _this$props4.onPreviewChange,
        theme = _this$props4.theme;
      var _this$props5 = this.props,
        minDate = _this$props5.minDate,
        maxDate = _this$props5.maxDate;
      minDate = minDate && (0, _startOfDay["default"])(minDate);
      maxDate = maxDate && (0, _endOfDay["default"])(maxDate);
      var monthDisplay = getMonthDisplayRange(month, dateOptions);
      var monthTestId = "".concat(testId, "_MONTH_").concat(month.getMonth(), "_").concat(month.getFullYear());
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
        theme: theme
      }, /*#__PURE__*/_react["default"].createElement(StyledMonth.MonthGrid, (0, _oxygenConfig.getTestAttributes)(monthTestId), showMonthName && this.renderMonthName(), showWeekDays && this.renderWeekDays(), (0, _eachDayOfInterval["default"])({
        start: monthDisplay.start,
        end: monthDisplay.end
      }).map(function (day) {
        var isStartOfMonth = (0, _isSameDay["default"])(day, monthDisplay.startDateOfMonth);
        var isEndOfMonth = (0, _isSameDay["default"])(day, monthDisplay.endDateOfMonth);
        var isOutsideMinMax = minDate && (0, _isBefore["default"])(day, minDate) || maxDate && (0, _isAfter["default"])(day, maxDate);
        var dayDisabled = _this2.isDayDisabled(day);
        return /*#__PURE__*/_react["default"].createElement(_Day["default"], {
          theme: theme,
          key: day.toString(),
          day: day,
          testId: "".concat(testId, "_MONTH_").concat(day.getMonth(), "_").concat(day.getFullYear(), "_DAY_").concat(day.getDate()),
          displayMode: displayMode,
          preview: showPreview ? preview : undefined,
          range: range,
          date: date,
          isPassive: !(0, _isWithinInterval["default"])(day, {
            start: monthDisplay.startDateOfMonth,
            end: monthDisplay.endDateOfMonth
          }),
          isDisabled: isOutsideMinMax || dayDisabled,
          isToday: (0, _isSameDay["default"])(day, now),
          isWeekend: (0, _isWeekend["default"])(day, dateOptions),
          isStartOfWeek: (0, _isSameDay["default"])(day, (0, _startOfWeek["default"])(day, dateOptions)),
          isEndOfWeek: (0, _isSameDay["default"])(day, (0, _endOfWeek["default"])(day, dateOptions)),
          isStartOfMonth: isStartOfMonth,
          isEndOfMonth: isEndOfMonth,
          dayNumberFormat: dayNumberFormat,
          locale: locale,
          onClick: onDayClick,
          onPreviewChange: onPreviewChange
        });
      })));
    }
  }]);
  return Month;
}(_react.PureComponent);
Month.propTypes = {
  month: _propTypes["default"].object.isRequired,
  testId: _propTypes["default"].string,
  dateOptions: _propTypes["default"].object,
  disabledDates: _propTypes["default"].array,
  enabledDates: _propTypes["default"].array,
  minDate: _propTypes["default"].object,
  maxDate: _propTypes["default"].object,
  displayMode: _propTypes["default"].oneOf(Object.values(_constants["default"])),
  showPreview: _propTypes["default"].bool,
  preview: _propTypes["default"].shape({
    startDate: _propTypes["default"].object,
    endDate: _propTypes["default"].object
  }),
  range: _propTypes["default"].shape({
    startDate: _propTypes["default"].object.isRequired,
    endDate: _propTypes["default"].object
  }),
  date: _propTypes["default"].object,
  dayNumberFormat: _propTypes["default"].string,
  showWeekDays: _propTypes["default"].bool,
  weekDayDisplayFormat: _propTypes["default"].string,
  showMonthName: _propTypes["default"].bool,
  monthDisplayFormat: _propTypes["default"].string,
  locale: _propTypes["default"].object,
  onDayClick: _propTypes["default"].func,
  onPreviewChange: _propTypes["default"].func,
  theme: _propTypes["default"].object.isRequired
};
Month.defaultProps = {
  testId: 'CALENDAR_MONTH',
  dateOptions: {
    weekStartsOn: 0,
    customEvenMonths: false
  },
  disabledDates: [],
  enabledDates: [],
  minDate: undefined,
  maxDate: undefined,
  displayMode: _constants["default"].DATE,
  showPreview: true,
  preview: undefined,
  range: undefined,
  date: undefined,
  dayNumberFormat: 'd',
  showWeekDays: true,
  weekDayDisplayFormat: 'EE',
  showMonthName: false,
  monthDisplayFormat: 'MMMM yyyy',
  locale: undefined,
  onDayClick: _lodash["default"],
  onPreviewChange: _lodash["default"]
};
var _default = (0, _oxygenConfig.withTheme)(Month, 'calendar');
exports["default"] = _default;